"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformOperation = exports.performTransform = exports.validateTransform = void 0;
const fflate_1 = require("fflate");
const jszip_1 = __importDefault(require("jszip"));
const common_1 = require("@finley-technologies/common");
const cleanupUtf8_1 = require("./cleanupUtf8");
const errorUtils_1 = require("./errorUtils");
const validateTransform = (transformation) => {
    const errors = [];
    if (transformation.compression === 'gz' &&
        transformation.file !== undefined) {
        // for gz transformation we do not support
        // specifying file name.
        errors.push({
            type: 'metadataValidation',
            message: 'unzip: gz compression does not support extracting specific file',
        });
    }
    if (errors.length > 0) {
        return {
            isValid: false,
            errors,
        };
    }
    return { isValid: true, data: null };
};
exports.validateTransform = validateTransform;
const performTransform = async ({ dataTapeBuffers, transformation, }) => {
    try {
        (0, common_1.finleyAssert)(dataTapeBuffers.length === 1, 'Expected 1 data tape buffer');
        const { file, compression, cleanupUTF8 } = transformation;
        if (compression === 'gz') {
            // process the input as gzip data
            const decompressed = (0, fflate_1.decompressSync)(dataTapeBuffers[0]);
            return {
                isValid: true,
                data: { outputBuffer: common_1.finleyBuffer.fromUint8Array(decompressed) },
                supplementals: [],
            };
        }
        // process the input as zip file
        const zip = await jszip_1.default.loadAsync(dataTapeBuffers[0]);
        // JSZip maintains file names in weird way.
        // for a single level zip. it is just the file name.
        // for a multi level zip, it is the full path. But this full path also includes the zipFile name itelf.
        // for example a zip file named (x.zip) with two files at top level, they are named as:
        // x.zip
        //  file1.txt   (can be found as: "file1.txt")
        //  file2.txt   (can be found as: "file2.txt")
        // for a zip file named (y.zip) with a folder inside it.
        // y.zip
        //   folder1
        //    file1.txt  (can be found as: "y/folder1/file1.txt")
        //    file2.txt  (can be found as: "y/folder1/file2.txt")
        // JSZip adds the zip file name if there are any folders inside it.
        // in our case we do not know the input zip file name, thus we cannot predict the file names.
        // if they have folders in it.
        // we will need to inspect if there is topLevel folder
        // we will iterate thru files, and then depending on existence of any folder
        // find the top level folder name.
        let topFolder = '';
        const allFiles = [];
        zip.forEach((relativePath, xfile) => {
            if (xfile.dir) {
                const thisTopFolder = relativePath.split('/')[0];
                if (!topFolder) {
                    topFolder = thisTopFolder;
                }
                else {
                    (0, common_1.finleyAssert)(thisTopFolder === topFolder, `Multiple top level folders found: ${topFolder} and ${thisTopFolder}`);
                }
            }
            else {
                allFiles.push(xfile.name);
            }
        });
        let effectiveFileName = null;
        if (!file) {
            // if file to extract is not specified, its expected that we have a
            // single file in the zip.
            (0, common_1.finleyAssert)(allFiles.length === 1, `Expected a single file in the zip, but [found:${allFiles.length}]`);
            effectiveFileName = allFiles[0];
        }
        else {
            // file to extract is specified.
            // lets construct the effective file name.
            effectiveFileName = topFolder ? `${topFolder}/${file}` : file;
        }
        const matchingFile = zip.file(effectiveFileName);
        if (!matchingFile) {
            throw new common_1.error.FinleyError(`File [${file}] (${effectiveFileName}) not found`);
        }
        let buffer = common_1.finleyBuffer.fromUint8Array(await matchingFile.async('uint8array'));
        if (cleanupUTF8) {
            buffer = (0, cleanupUtf8_1.cleanUpFileContent)(buffer, cleanupUTF8.startOffset);
        }
        return {
            isValid: true,
            data: { outputBuffer: buffer },
            supplementals: [],
        };
    }
    catch (error) {
        return (0, errorUtils_1.convertErrorToTapeFailureResult)(error, 'unzip: ');
    }
};
exports.performTransform = performTransform;
exports.transformOperation = {
    operation: 'unzip',
    validateTransform: exports.validateTransform,
    performTransform: exports.performTransform,
};
//# sourceMappingURL=unzip-transform.js.map